import React, { useEffect, useState } from 'react'
import { HeaderContent, HeaderMain } from './styles'
import HeaderContentC from '../HeaderContent'
import HeaderContentGestor from '../HeaderContent/gestor'
import api from '../../../services/axios'
import { useAuth } from '../../../context/AuthContext'

//img

function HeaderPainel() {
  const { user } = useAuth()
  const [userRole, setUserRole] = useState<string | null>(null)

  useEffect(() => {
    async function fetchUserName() {
      try {
                setUserRole(user?.role ?? null)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        if (err.response) {
          console.error('Erro na API:', err.response.status, err.response.data)
        }
      }
    }

    fetchUserName()
  }, [])

  return (
    <HeaderMain>
      <HeaderContent>
        {userRole === 'administrador' || userRole === 'conferente' ? <HeaderContentC /> : <HeaderContentGestor />}
      </HeaderContent>
    </HeaderMain>
  )
}

export default HeaderPainel
